/**
 * TutorialOverlay — greys out everything except the parts of the step.
 *
 * One SVG with a mask: a white sheet with a black rounded rect punched through
 * it for each spotlight. A step can have several — "drag this tile onto that
 * canvas" is two places at once, which is the reason this is hand-rolled rather
 * than a tour library.
 */

import React from 'react';
import styles from './TutorialOverlay.module.css';

const MASK_ID = 'tutorial-spotlight-mask';
const PADDING = 6;
const RADIUS = 8;

const TutorialOverlay = ({ rects }) => {
    const holes = (rects || []).filter((rect) => rect.w > 0 && rect.h > 0);

    return (
        <svg className={styles.overlay} aria-hidden="true" focusable="false">
            <defs>
                <mask id={MASK_ID}>
                    <rect x="0" y="0" width="100%" height="100%" fill="white" />
                    {holes.map((rect, index) => (
                        <rect
                            key={`hole-${index}`}
                            className={styles.hole}
                            x={rect.x - PADDING}
                            y={rect.y - PADDING}
                            width={rect.w + PADDING * 2}
                            height={rect.h + PADDING * 2}
                            rx={RADIUS}
                        />
                    ))}
                </mask>
            </defs>

            <rect
                className={styles.dim}
                x="0"
                y="0"
                width="100%"
                height="100%"
                mask={`url(#${MASK_ID})`}
            />

            {holes.map((rect, index) => (
                <rect
                    key={`ring-${index}`}
                    className={styles.ring}
                    x={rect.x - PADDING}
                    y={rect.y - PADDING}
                    width={rect.w + PADDING * 2}
                    height={rect.h + PADDING * 2}
                    rx={RADIUS}
                />
            ))}
        </svg>
    );
};

export default TutorialOverlay;
